<template>
  <header class="MobileFilterFull_header py-8 px-10">
    <div class="flex items-center justify-between mt-4">
      <div class="flex items-center">
        <div @click="handleBack" v-if="showBackBtn" class="pr-10">
          <FaIcon :icon="['fas', 'chevron-left']" class="text-xl text-blackest" />
        </div>
        <h1 class="my-1.5 text-2xl text-center text-black font-bold">{{ label || "Filters & Sort" }}</h1>
      </div>
      <a class="cursor-pointer" @click.prevent="handleClose()">
        <FaIcon :icon="['far', 'times']" class="text-2xl text-blackest" />
      </a>
    </div>
  </header>
</template>

<script setup>
defineProps({
  handleClose: {
    type: Function,
    required: true,
  },
  label: {
    type: String,
    required: false,
  },
  handleBack: {
    type: Function,
    required: false,
  },
  showBackBtn: {
    type: Boolean,
    required: false,
  },
})
</script>

<script>
export default {
  name: "MobileHeader",
}
</script>
